import { Data, List, Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import FileDownloadComponentVM from '../../../Common/Components/FileDownload/FileDownloadComponentVM';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import TransactionLookup from '../Models/Lookups/TransactionLookup';
import TransactionSearchCriteria from '../Models/Queries/TransactionSearchCriteria';
import { StaticDataTypes } from '../../../Maintenance/StaticData/StaticDataTypes';
import InstrumentSearchLookup from '../../../DataInterception/InstrumentMapping/Models/InstrumentSearchLookup';
import ClientLookup from '../../../DataInterception/ClientAccountMapping/Models/ClientLookup';

@NeoModel
export default class TransactionsVM extends Views.ViewModelBase {

    constructor(
        public fileDownloadApiClient = AppService.get(Types.ApiClients.FileDownloadApiClient),
        public transactionsApiClient = AppService.get(Types.ApiClients.TransactionsApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache)) {
        super(taskRunner);
    }

    public fileGroupingList = new List(StaticServiceProviderFileGroupingModel);
    public transactionsSearchCriteria = new TransactionSearchCriteria();
    public fileDownloadVM = new FileDownloadComponentVM();

    public instruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public filteredInstruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public clientAccounts: Model.PlainObject<ClientLookup>[] = [];
    public filteredClientAccounts: Model.PlainObject<ClientLookup>[] = [];

    public transactionsPageManager = new Data.PageManager(this.transactionsSearchCriteria, TransactionLookup, this.transactionsApiClient.getTransactionsPagedList, {
        pageSize: 10,
        sortAscending: true,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner,
        afterFetch: this.setIsExpandedProp.bind(this),
    });

    public async initialise() {
        await Promise.all([
            this.loadFileGroupings(),
            this.populateInstruments(),
            this.populateClientAccounts(),
        ]);
    }

    public async populateInstruments() {
        this.instruments = await this.staticDataCache.instruments.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.description!.localeCompare(y.description!)));
        this.filteredInstruments = this.instruments.slice(0, 10);
    }

    public async populateClientAccounts() {
        this.clientAccounts = await this.staticDataCache.clientAccounts.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.clientDescription.localeCompare(y.clientDescription)));
        this.filteredClientAccounts = this.clientAccounts.slice(0, 10);
    }

    public async downloadTransactionsFile() {
        await this.taskRunner.run(async () => {
           this.fileDownloadApiClient.downloadTransactionsReportFile(this.transactionsSearchCriteria.toJSObject());
        });
    }

    public async loadFileGroupings() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.fileGroupingList.set(response.data);
    }

    public async search() {
        await this.transactionsPageManager.refreshData();
    }

    public setIsExpandedProp(data: TransactionLookup[]) {
        data.forEach(transaction => {
            if (transaction.transactionDetail.length > 0 && transaction.isExcludedInd === false) {
                transaction.isExpanded = false;
            }
        });
    }
}